type SessionCompletedAtSource = {
  ended_at?: string | Date | null;
  updated_at?: string | Date | null;
  started_at?: string | Date | null;
  created_at?: string | Date | null;
};

export const resolveSessionCompletedAt = (
  source: SessionCompletedAtSource | null | undefined
): string | Date | null =>
  source?.ended_at ??
  source?.updated_at ??
  source?.started_at ??
  source?.created_at ??
  null;

export const formatSessionCompletedAtForExport = (
  value: string | Date | null | undefined
): string => {
  if (value == null || value === '') {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('it-IT');
};
